import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";
import { Reveal } from "@/components/site/Reveal";
import { FAQS, waLink, onWhatsApp } from "@/lib/site";

export const Faq = () => {
  return (
    <section id="duvidas" className="relative py-24 md:py-32">
      <div className="container-x grid lg:grid-cols-[0.8fr_1.2fr] gap-12 lg:gap-16">
        <Reveal>
          <span className="text-brand font-display text-lg font-bold uppercase tracking-[0.2em]">Dúvidas</span>
          <h2 className="mt-3 font-display text-4xl md:text-6xl font-black text-white leading-[0.92]">
            Perguntas Frequentes
          </h2>
          <p className="mt-5 text-lg text-zinc-400">
            Não encontrou o que procurava? Fale com a nossa equipe agora mesmo.
          </p>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="faq-cta"
            onClick={() => onWhatsApp("faq")}
            className="mt-6 group inline-flex items-center gap-3 bg-wapp hover:bg-wapp-hover text-black font-display font-bold uppercase tracking-wider text-lg px-7 py-4 rounded-sm transition-all active:scale-95"
          >
            <WhatsAppIcon className="h-6 w-6" /> Tirar Dúvida no WhatsApp
            <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
                <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left font-display text-xl md:text-2xl font-bold text-white hover:text-brand hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-zinc-400 pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
